import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "../../../../vue";
import { ExprInput } from '@tencent/ui-core';
import commonStyles from "../../../../style/class.module.css";
import { IMethodEditorState } from "../../MethodEditorState";
import styles from "./style.module.css";
import { Radio } from 'ant-design-vue';
import MethodParams from "./MethodParams";
import LabelSwitch from "../LabelSwitch";
import { getSourceProtocolBySource } from "../../../../core/stateJS/utils/protocol";
let RequestForm = class RequestForm extends Vue {
  constructor() {
    super(...arguments);
    this.isShowSettings = false;
  }
  get dataStub() {
    return this.state.designer.renderer.ucDataStub;
  }
  get skipCode() {
    return this.formInfo.params.skipCode || false;
  }
  set skipCode(val) {
    this.$set(this.formInfo.params, 'skipCode', val);
  }
  /**
   * 有多个接口需要调用 list count
   */
  get hasMoreCgi() {
    return Array.isArray(this.formInfo.cgi) && this.formInfo.cgi.length > 1;
  }
  /**
   * 特殊逻辑，支持关闭count接口
   */
  get hasCountInListCountMethod() {
    var _this$state$sourceIns, _this$formInfo$cgi;
    if (!((_this$state$sourceIns = this.state.sourceInstance) !== null && _this$state$sourceIns !== void 0 && _this$state$sourceIns.isDB)) {
      return false;
    }
    return this.hasMoreCgi && ((_this$formInfo$cgi = this.formInfo.cgi) === null || _this$formInfo$cgi === void 0 ? void 0 : _this$formInfo$cgi.includes('count'));
  }
  get settings() {
    const instance = this.state.dataStub.value;
    const protocol = getSourceProtocolBySource(instance);
    const {
      CODE,
      MESSAGE
    } = protocol;
    return [{
      ctx: this,
      id: 'skipCode',
      title: this.renderLabel('是否跳过错误码判断', ''),
      Comp: Radio.Group,
      props: {
        options: [{
          value: true,
          label: '跳过'
        }, {
          value: false,
          label: '不跳过'
        }]
      }
    }, {
      id: 'codeKey',
      title: this.renderLabel('从哪里取错误码', `"${CODE}"`),
      Comp: ExprInput,
      props: {
        dataStub: this.dataStub
      }
    }, {
      id: 'msgKey',
      title: this.renderLabel('从哪里取错误消息', `"${MESSAGE}"`),
      Comp: ExprInput,
      props: {
        dataStub: this.dataStub
      }
    }, {
      id: 'showMsg',
      title: this.renderLabel('是否显示【成功/失败提示】', '显示'),
      Comp: Radio.Group,
      props: {
        options: [{
          value: true,
          label: '显示'
        }, {
          value: false,
          label: '不显示'
        }]
      }
    }, {
      id: 'succMsg',
      title: '成功时显示的提示文案',
      Comp: ExprInput,
      props: {
        dataStub: this.dataStub
      }
    }];
  }
  get hasSetting() {
    const hasSetting = ['codeKey', 'msgKey', 'showMsg', 'succMsg'].some(key => {
      const val = this.formInfo.params[key];
      if (typeof val === 'string') return val.trim().length > 0;
      return val !== undefined;
    }); // 其中一个有值就显示
    return hasSetting;
  }
  get hasArgs() {
    var _this$formInfo$args;
    return Boolean((_this$formInfo$args = this.formInfo.args) === null || _this$formInfo$args === void 0 ? void 0 : _this$formInfo$args.length);
  }
  created() {
    this.$watch(() => this.state.method, () => {
      this.isShowSettings = false;
    });
  }
  renderLabel(title, defaultValue) {
    const h = this.$createElement;
    return h("div", {
      "class": styles.formLabel
    }, [h("span", [title]), ' ', defaultValue && h("span", {
      "class": styles.tip
    }, ["(\u9ED8\u8BA4\u4E3A", h("span", {
      "class": styles.defaultValue
    }, [` ${defaultValue}`]), ")"])]);
  }
  get cgiName() {
    const {
      cgi
    } = this.formInfo;
    if (!cgi) return '接口';
    return (Array.isArray(cgi) ? cgi : [cgi]).map(name => `【${name}】`).join('');
  }
  renderCountCheckbox() {
    var _this$formInfo$params;
    const h = this.$createElement;
    if (!this.hasCountInListCountMethod) {
      return null;
    }
    const onChange = e => {
      const {
        checked
      } = e.target;
      const {
        params
      } = this.formInfo;
      if (checked) {
        this.$set(params, 'excludeCgiMap', params.excludeCgiMap || {});
        Object.assign(params.excludeCgiMap, {
          count: true
        });
      } else if (params.excludeCgiMap) {
        this.$delete(params.excludeCgiMap, 'count');
        if (Object.keys(params.excludeCgiMap).length <= 0) {
          this.$delete(params, 'excludeCgiMap');
        }
      }
    };
    return h("a-form-item", {
      "attrs": {
        "colon": false
      }
    }, [h("a-checkbox", {
      "attrs": {
        "checked": (_this$formInfo$params = this.formInfo.params.excludeCgiMap) === null || _this$formInfo$params === void 0 ? void 0 : _this$formInfo$params.count
      },
      "on": {
        "change": onChange
      }
    }, ["\u662F\u5426\u5173\u95EDcount\u8BF7\u6C42"])]);
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": styles.requestForm
    }, [this.hasArgs && h("div", {
      "class": styles.configItem
    }, [h("div", {
      "class": commonStyles.label
    }, ["\u65B9\u6CD5\u53C2\u6570"]), h(MethodParams, {
      "attrs": {
        "formInfo": this.formInfo
      }
    })]), h("div", {
      "class": styles.configItem
    }, [h("div", {
      "class": commonStyles.label
    }, ["\u914D\u7F6E", h("span", {
      "class": styles.primaryColor
    }, [this.cgiName]), "\u8BF7\u6C42\u53C2\u6570"]), h(ExprInput, {
      "attrs": {
        "dataStub": this.dataStub
      },
      "model": {
        value: this.formInfo.params.request,
        callback: $$v => {
          this.$set(this.formInfo.params, "request", $$v);
        }
      }
    }), this.renderCountCheckbox()]), h(LabelSwitch, {
      "attrs": {
        "title": "消息提示配置",
        "forceShow": this.hasSetting
      },
      "model": {
        value: this.isShowSettings,
        callback: $$v => {
          this.isShowSettings = $$v;
        }
      }
    }), (this.hasSetting || this.isShowSettings) && h("div", {
      "class": [styles.configItem, styles.settings]
    }, [this.settings.map(item => {
      const {
        id,
        props,
        title,
        Comp,
        ctx
      } = item;
      return h("a-form-item", {
        "attrs": {
          "label": title,
          "colon": false
        }
      }, [ctx ? h(Comp, _mergeJSXProps([{}, {
        "props": props
      }, {
        "model": {
          value: ctx[id],
          callback: $$v => {
            this.$set(ctx, id, $$v);
          }
        }
      }])) : h(Comp, _mergeJSXProps2([{}, {
        "props": props
      }, {
        "model": {
          value: this.formInfo.params[id],
          callback: $$v => {
            this.$set(this.formInfo.params, id, $$v);
          }
        }
      }]))]);
    })])]);
  }
};
__decorate([IMethodEditorState], RequestForm.prototype, "state", void 0);
__decorate([Prop()], RequestForm.prototype, "formInfo", void 0);
RequestForm = __decorate([Component({
  name: 'RequestForm'
})], RequestForm);
export default RequestForm;
//# sourceMappingURL=RequestForm.js.map
